<template>

  <div class="row">
    <div class="col-12 mb-3">
      <div class="pull-right">
        <span>Página {{currentPage}} de {{totalPages}}</span>
      </div>
    </div>
    <div class="col-12">
      <div class="dataTables_paginate paging_simple_numbers" id="datatable_paginate">
        <ul class="pagination pull-right">
          <li class="paginate_button page-item">
            <a href="javascript:void(0);" aria-controls="datatable" @click="previusPage();" v-bind:class="{'disabled': (currentPage == 1)}" class="page-link">Anterior</a>
          </li>
          <li>
            <input class="current-page" type="number" v-model="selectedPage" @keyup.enter="goToPage()"/>
          </li>
          <li class="paginate_button page-item">
            <a href="javascript:void(0);" aria-controls="datatable" @click="nextPage();" v-bind:class="{'disabled': (currentPage == totalPages)}" class="page-link">Siguiente</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'pagination',

    props: {
      currentPage: Number,
      totalPages: Number
    },

    watch: {
      currentPage: function(newVal, oldVal) { // watch it
        this.selectedPage = newVal;
      }
    },

    data () {
      return {
        selectedPage: 1
      }
    },

    methods: {
      goToPage: function () {
        if(this.selectedPage > this.totalPages) {
          this.selectedPage = this.totalPages;
        }
        if(this.selectedPage < 1) {
          this.selectedPage = 1;
        }
        this.$parent.$emit('pageChanged:pagination',  Number(this.selectedPage))
      },
      previusPage : function () {
        this.selectedPage = this.currentPage - 1;
        if(this.selectedPage > this.totalPages) {
          this.selectedPage = this.totalPages;
        }
        if(this.selectedPage < 1) {
          this.selectedPage = 1;
        }
        this.$parent.$emit('pageChanged:pagination',  Number(this.selectedPage))
      },
      nextPage : function () {
        this.selectedPage = this.currentPage + 1;
        if(this.selectedPage > this.totalPages) {
          this.selectedPage = this.totalPages;
        }
        if(this.selectedPage < 1) {
          this.selectedPage = 1;
        }
        this.$parent.$emit('pageChanged:pagination',  Number(this.selectedPage))
      }
    }

  }
</script>

<style scoped>
  input.current-page {
    width: 65px;
    height: 36px;
    padding: 10px;
    border: 1px solid #ddd;
    border-right: 2px solid #ddd;
    text-align: center;
  }

  a.disabled {
    pointer-events: none;
    cursor: not-allowed;
    color: #e1e3e9;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue